import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, MapPin } from "lucide-react";

const INDUSTRY_LABELS = {
  hospitals: "Hospitals", pharma: "Pharma", diagnostics: "Diagnostics",
  medtech: "MedTech", biotech: "Biotech", digital_health: "Digital Health",
  insurance: "Insurance", health_ai: "Health AI", telemedicine: "Telemedicine",
  wellness: "Wellness", consulting: "Consulting",
};

export default function LeaderCard({ leader }) {
  const label = INDUSTRY_LABELS[leader.industry] || leader.industry;
  return (
    <Link
      to={`/network/leaders/${leader.id}`}
      className="group block rounded-lg border border-border bg-white p-5 hover:border-primary transition-colors"
      data-testid={`leader-card-${leader.id}`}
    >
      <div className="flex items-start gap-3">
        <div className="w-11 h-11 rounded-full bg-primary/8 text-primary flex items-center justify-center font-serif text-lg shrink-0" aria-hidden>
          {initials(leader.name)}
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2">
            <h3 className="font-serif text-lg text-primary truncate">{leader.name}</h3>
            {leader.status === "in_transition" && (
              <span className="rounded-full bg-accent/15 text-accent text-[10px] font-semibold uppercase tracking-wider px-2 py-0.5">
                In transition
              </span>
            )}
          </div>
          <div className="text-xs text-muted-foreground mt-0.5">{leader.current_title}</div>
        </div>
      </div>

      <div className="mt-3 text-sm text-primary font-medium truncate">{leader.current_organization}</div>

      <div className="mt-3 flex items-center gap-3 text-xs text-muted-foreground">
        <span className="inline-flex items-center gap-1"><MapPin size={11} /> {leader.city}</span>
        <span>·</span>
        <span>{leader.years_experience}+ yrs</span>
      </div>

      <div className="mt-4 flex items-center justify-between text-xs">
        <span className="rounded-full bg-muted text-primary px-2 py-0.5 font-medium">{label}</span>
        <span className="text-primary font-medium inline-flex items-center gap-1 group-hover:gap-2 transition-all">
          View profile <ArrowRight size={11} />
        </span>
      </div>
    </Link>
  );
}

function initials(name) {
  if (!name) return "?";
  return name
    .replace(/^Dr\.?\s+/i, "")
    .split(/\s+/)
    .map((w) => w[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();
}
